/** A plain string is a paragraph; a string array is a bullet list. */
export type FaqBlock = string | string[]

export interface FaqItem {
  question: string
  answer: FaqBlock[]
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive the material?',
    answer: [
      'You receive digital access immediately after payment.',
      'The material is delivered in PDF format so you can download it and use it from your phone, tablet, laptop or computer.',
      'You can also print the pages you want to use courtside.',
    ],
  },
  {
    question: 'Is this only for experienced futsal coaches?',
    answer: [
      'No.',
      'FUTSAL 360 READY™ is designed to be useful for developing coaches and experienced coaches who want to save planning time.',
      'The visual diagrams, session structures and coaching cues make the material easy to follow.',
    ],
  },
  {
    question: 'Is this only for youth futsal?',
    answer: [
      'No.',
      'The sessions can be adapted to different ages and playing levels.',
      'The Mixed-Level Adaptation Kit™ helps you simplify or increase the difficulty of activities depending on your group.',
    ],
  },
  {
    question: 'Do I have to follow the sessions exactly?',
    answer: [
      'No.',
      'You can follow a complete session, replace one activity, adjust the duration, or combine exercises from different volumes.',
      'The system gives you structure without forcing you into one rigid method.',
    ],
  },
  {
    question: 'Does it include videos?',
    answer: [
      'No.',
      'FUTSAL 360 READY™ is a visual digital PDF coaching system.',
      'Movements are explained using step-by-step illustrations, futsal diagrams, arrows, player positions, progressions and coaching cues.',
    ],
  },
  {
    question: 'Can I download and print the material?',
    answer: [
      'Yes.',
      'You can download the PDFs and use them digitally or print selected pages for training.',
    ],
  },
  {
    question: 'Is it a subscription?',
    answer: ['No.', 'It is a one-time payment.'],
  },
  {
    question: 'Is everything in English?',
    answer: ['Yes.', 'The complete FUTSAL 360 READY™ system is in English.'],
  },
  {
    question: 'Do I need special equipment?',
    answer: [
      'No.',
      'Most sessions use standard futsal equipment such as balls, cones, bibs and goals.',
    ],
  },
  {
    question: 'How does the 7-day guarantee work?',
    answer: [
      'You have 7 days to make sure the files are accessible, complete and match the product described on this page.',
      'If there is a delivery or content issue, contact us so we can resolve it.',
      'If we cannot resolve the issue, you receive a full refund.',
    ],
  },
]
